import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59a2809b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "compo-api-main",
  "data-test": "compo-api-main"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "compo-api-intro" }, "Composition API helps us to encapsulate bits of functionality that we want to reuse. Write reusable functional code in seperate files (e.g. src/composables/...) and import respective functions in your component. THen include the functions/values in the setup directive.", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Composable sample")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Order from: ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Options", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("By clicking on the button below you can toggle a component that uses "),
  /*#__PURE__*/_createElementVNode("code", null, "reactive()"),
  /*#__PURE__*/_createTextVNode(" instead of "),
  /*#__PURE__*/_createElementVNode("code", null, "ref()"),
  /*#__PURE__*/_createTextVNode(". It looks perfectly the same, just the code is different.")
], -1))

import {ref} from "vue";
import alternativeScript from '../components/CompoAPIreactive.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const restaurantName = ref(`Let's taco bout it`),
        options = ref(["Lengua", "Carnitas", "Al Pastor", "Pollo"]),
        numItems = ref(0),
        deliveryTime = ref(25),
        freeDelivery = true;

    const log = () => {
      console.log("$Route: ")
    }

    const addItems = () => {
      log();
      numItems.value++;
    }

    const testAlternative = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_link, { to: {name: 'Composables'} }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createElementVNode("h3", null, [
      _hoisted_4,
      _createElementVNode("strong", null, _toDisplayString(restaurantName.value), 1)
    ]),
    _hoisted_5,
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
        return (_openBlock(), _createElementBlock("li", { key: option }, _toDisplayString(option), 1))
      }), 128)),
      _createElementVNode("p", null, "Delivery time: " + _toDisplayString(deliveryTime.value) + " minutes", 1),
      freeDelivery
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Free Delivery!"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      onClick: addItems,
      "data-test": "add-item-button"
    }, "Add an item: " + _toDisplayString(numItems.value), 1),
    _hoisted_7,
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (testAlternative.value = !testAlternative.value))
      }, "Test alternative")
    ]),
    _createElementVNode("div", null, [
      (testAlternative.value)
        ? (_openBlock(), _createBlock(alternativeScript, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})